export const LOAD_SRACUSTOMERUSERS_SUCCESS = "LOAD_SRACUSTOMERUSERS_SUCCESS";

export const CREATE_SRACUSTOMERUSER_SUCCESS = "CREATE_SRACUSTOMERUSER_SUCCESS";

export const SAVE_SRACUSTOMERUSER_SUCCESS = "SAVE_SRACUSTOMERUSER_SUCCESS";

export const DELETE_SRACUSTOMERUSER_SUCCESS = "DELETE_SRACUSTOMERUSER_SUCCESS";

export const LOAD_SRACUSTOMERUSER_DETAIL_SUCCESS = "LOAD_SRACUSTOMERUSER_DETAIL_SUCCESS";
